import styled from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import FlexItemOrg from "../FlexItemOrg";
import SurfaceOrg from "../SurfaceOrg";
export var calculatorContainerMaxWidth = 650;
export var StyledContainer = styled.div.withConfig({
  componentId: "sc-t3ef0e-0"
})(["container-type:inline-size;"]);
export var StyledMarketplaceCalculatorOrg = styled(SurfaceOrg).withConfig({
  componentId: "sc-t3ef0e-1"
})(["display:flex;flex-wrap:wrap;gap:", ";"], space(2));
export var StyledConfigurationBox = styled(FlexItemOrg).withConfig({
  componentId: "sc-t3ef0e-2"
})(["min-width:", ";padding:", " ", " ", " ", ";", "{padding:", " ", " ", " ", ";}"], unit(320), space(3), space(2), space(2), space(2), breakpoint("medium"), space(4), space(3), space(3), space(3));